import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(calculateRowsTask),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(configureTableTask),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(pollingTask),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(startPollingTask),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(stopPollingTask);

import { List, Map, fromJS } from 'immutable';
import isarray from 'isarray';
import { call, cancel, delay, fork, put, select, takeEvery } from 'redux-saga/effects';
import { action, dispatch, regHandlers, regSaga } from '../../store';
import { mountForm, unmountForm } from '..';
export var hasData = function hasData(data) {
  return isarray(data) || data instanceof List;
};

var noop = function noop() {
  return null;
};

var getDataSource = function getDataSource(tableData) {
  var tableOptions = tableData.get('tableOptions');
  var dataSourceFn = tableData.get('dataSource') || noop;
  return dataSourceFn(tableOptions);
};

export var isClientSide = function isClientSide(tableData) {
  var data = tableData.get('data');
  var dataSource = getDataSource(tableData);
  return hasData(data) && (dataSource && (dataSource.clientSideSearch === true || dataSource.clientSide) || !dataSource);
};
export var clientSideGotoPage = function clientSideGotoPage(tableData, pageNumber) {
  var data = tableData.get('data');
  var pageSize = tableData.get('pageSize');
  var newOffset = (pageNumber - 1) * pageSize;

  if (typeof pageNumber !== 'number' || pageNumber < 1) {
    return tableData;
  }

  if (newOffset > data.size) return tableData;
  return tableData.set('pageOffset', newOffset);
};

var clientSideNextPage = function clientSideNextPage(tableData) {
  return tableData.update('pageOffset', function (pageOffset) {
    return pageOffset + tableData.get('pageSize');
  });
};

var clientSidePrevPage = function clientSidePrevPage(tableData) {
  return tableData.update('pageOffset', function (pageOffset) {
    return Math.max(0, pageOffset - tableData.get('pageSize'));
  });
};

export var serverSideGotoPage = function serverSideGotoPage(tableData, pageNumber) {
  var pageTokens = tableData.get('pageTokens');
  var tokenLocation = pageNumber - 2;

  if (typeof pageNumber !== 'number' || pageNumber < 1 || pageNumber > pageTokens.size) {
    return tableData;
  }

  if (pageNumber === 1) {
    return tableData.set('loading', true).set('nextPageToken', null).set('pageTokens', List());
  }

  return tableData.set('loading', true).set('nextPageToken', pageTokens.get(tokenLocation)).set('pageTokens', pageTokens.slice(0, tokenLocation));
};

var serverSideNextPage = function serverSideNextPage(tableData) {
  return tableData.set('loading', true).set('nextPageToken', tableData.get('currentPageToken')).update('pageTokens', function (pt) {
    return pt.push(tableData.get('currentPageToken'));
  });
};

var serverSidePrevPage = function serverSidePrevPage(tableData) {
  return tableData.set('loading', true).update('pageTokens', function (pt) {
    return pt.pop();
  }).update(function (t) {
    return t.set('nextPageToken', t.get('pageTokens').last());
  });
}; // should be '' except if op is between, or in


var getInitialFilterValue = function getInitialFilterValue(column) {
  return column.has('initial') ? column.get('initial') : column.get('filter') === 'between' ? List(['', '']) : column.get('filter') === 'in' ? List() : '';
};

export var generateFilters = function generateFilters(tableKey, columns) {
  return Map(columns.filter(function (c) {
    return c.get('filter');
  }).reduce(function (filters, column) {
    return filters.set(column.get('value'), Map({
      value: getInitialFilterValue(column),
      column: column
    }));
  }, Map()));
};

var evaluateValidFilters = function evaluateValidFilters(table) {
  var validateFilters = table.get('onValidateFilters');
  return validateFilters ? validateFilters(table.get('filters')) : true;
};

export var generateInitialSortColumn = function generateInitialSortColumn(sortColumn, columns) {
  return sortColumn ? columns.find(function (col) {
    return col.get('value') === sortColumn;
  }) : null;
};
regHandlers({
  MOUNT_TABLE: function MOUNT_TABLE(state, _ref) {
    var tableKey = _ref.payload.tableKey;
    return state.setIn(['tables', tableKey, 'mounted'], true);
  },
  UNMOUNT_TABLE: function UNMOUNT_TABLE(state, _ref2) {
    var tableKey = _ref2.payload.tableKey;
    return state.deleteIn(['tables', tableKey]);
  },
  CONFIGURE_TABLE: function CONFIGURE_TABLE(state, _ref3) {
    var _ref3$payload = _ref3.payload,
        tableKey = _ref3$payload.tableKey,
        data = _ref3$payload.data,
        dataSource = _ref3$payload.dataSource,
        columns = _ref3$payload.columns,
        _ref3$payload$pageSiz = _ref3$payload.pageSize,
        pageSize = _ref3$payload$pageSiz === void 0 ? 25 : _ref3$payload$pageSiz,
        _ref3$payload$default = _ref3$payload.defaultSortColumn,
        defaultSortColumn = _ref3$payload$default === void 0 ? null : _ref3$payload$default,
        _ref3$payload$default2 = _ref3$payload.defaultSortDirection,
        defaultSortDirection = _ref3$payload$default2 === void 0 ? 'desc' : _ref3$payload$default2,
        tableOptions = _ref3$payload.tableOptions,
        onValidateFilters = _ref3$payload.onValidateFilters,
        filterForm = _ref3$payload.filterForm,
        onFetch = _ref3$payload.onFetch;
    return !state.getIn(['tables', tableKey, 'mounted']) ? state : state.hasIn(['tables', tableKey, 'configured']) ? state.setIn(['tables', tableKey, 'initialize'], false) : state.mergeIn(['tables', tableKey], Map({
      data: hasData(data) ? fromJS(data) : data,
      dataSource: dataSource,
      tableOptions: tableOptions,
      columns: columns,
      rows: List(),
      initializing: true,
      loading: true,
      pageSize: pageSize,
      sortColumn: generateInitialSortColumn(defaultSortColumn, columns),
      sortDirection: defaultSortDirection,
      // Pagination
      currentPageToken: null,
      nextPageToken: null,
      pageTokens: List(),
      pageOffset: 0,
      count: null,
      error: null,
      // Filtering
      filterForm: filterForm,
      filters: generateFilters(tableKey, columns),
      appliedFilters: generateFilters(tableKey, columns),
      validFilters: true,
      onValidateFilters: onValidateFilters,
      onFetch: onFetch,
      configured: true,
      initialize: true
    }));
  },
  SET_ROWS: function SET_ROWS(state, _ref4) {
    var _ref4$payload = _ref4.payload,
        tableKey = _ref4$payload.tableKey,
        rows = _ref4$payload.rows,
        data = _ref4$payload.data,
        nextPageToken = _ref4$payload.nextPageToken,
        count = _ref4$payload.count,
        _ref4$payload$error = _ref4$payload.error,
        error = _ref4$payload$error === void 0 ? null : _ref4$payload$error;
    return state.updateIn(['tables', tableKey], function (table) {
      return table && table.set('rows', rows).set('data', data).set('currentPageToken', nextPageToken).set('nextPageToken', null).set('count', count).set('error', error).set('initializing', false).set('loading', false);
    });
  },
  NEXT_PAGE: function NEXT_PAGE(state, _ref5) {
    var tableKey = _ref5.payload.tableKey;
    return state.updateIn(['tables', tableKey], function (tableData) {
      return isClientSide(tableData) ? clientSideNextPage(tableData) : serverSideNextPage(tableData);
    }).setIn(['tables', tableKey, 'error'], null);
  },
  PREV_PAGE: function PREV_PAGE(state, _ref6) {
    var tableKey = _ref6.payload.tableKey;
    return state.updateIn(['tables', tableKey], function (tableData) {
      return isClientSide(tableData) ? clientSidePrevPage(tableData) : serverSidePrevPage(tableData);
    }).setIn(['tables', tableKey, 'error'], null);
  },
  GOTO_PAGE: function GOTO_PAGE(state, _ref7) {
    var _ref7$payload = _ref7.payload,
        tableKey = _ref7$payload.tableKey,
        pageNumber = _ref7$payload.pageNumber;
    return state.updateIn(['tables', tableKey], function (tableData) {
      return isClientSide(tableData) ? clientSideGotoPage(tableData, pageNumber) : serverSideGotoPage(tableData, pageNumber);
    }).setIn(['tables', tableKey, 'error'], null);
  },
  SORT_COLUMN: function SORT_COLUMN(state, _ref8) {
    var _ref8$payload = _ref8.payload,
        tableKey = _ref8$payload.tableKey,
        column = _ref8$payload.column;
    return state.updateIn(['tables', tableKey], function (t) {
      var sortColumn = t.get('sortColumn');
      var sortDirection = t.get('sortDirection');
      return t // When sorting changes, reset pagination.
      .set('pageOffset', 0) // Update the sort column / direction.
      .set('sortDirection', sortColumn === column ? sortDirection === 'desc' ? 'asc' : 'desc' : 'asc').set('sortColumn', column).set('error', null);
    });
  },
  SET_FILTER: function SET_FILTER(state, _ref9) {
    var _ref9$payload = _ref9.payload,
        tableKey = _ref9$payload.tableKey,
        filter = _ref9$payload.filter,
        value = _ref9$payload.value;
    return state.updateIn(['tables', tableKey], function (table) {
      return table.setIn(['filters', filter, 'value'], value).set('validFilters', evaluateValidFilters(table));
    });
  },
  APPLY_FILTERS: function APPLY_FILTERS(state, _ref10) {
    var tableKey = _ref10.payload.tableKey;
    return state.updateIn(['tables', tableKey], function (table) {
      return table.set('loading', true).set('appliedFilters', state.getIn(['tables', tableKey, 'filters'])).set('pageOffset', 0).set('currentPageToken', null).set('nextPageToken', null).set('pageTokens', List()).set('error', null);
    });
  },
  APPLY_FILTER_FORM: function APPLY_FILTER_FORM(state, _ref11) {
    var _ref11$payload = _ref11.payload,
        tableKey = _ref11$payload.tableKey,
        appliedFilters = _ref11$payload.appliedFilters;
    return state.updateIn(['tables', tableKey], function (table) {
      return table.set('loading', true).set('appliedFilters', appliedFilters).set('pageOffset', 0).set('currentPageToken', null).set('nextPageToken', null).set('pageTokens', List()).set('error', null);
    });
  },
  REFETCH_TABLE_DATA: function REFETCH_TABLE_DATA(state, _ref12) {
    var tableKey = _ref12.payload.tableKey;
    return state.hasIn(['tables', tableKey]) ? state.updateIn(['tables', tableKey], function (tableData) {
      return tableData.get('dataSource') ? tableData.set('loading', true).set('pageOffset', 0).set('currentPageToken', null).set('nextPageToken', null).set('pageTokens', List()).set('data', null).set('error', null) : tableData;
    }) : state;
  },
  CLEAR_TABLE_FILTERS: function CLEAR_TABLE_FILTERS(state, _ref13) {
    var tableKey = _ref13.payload.tableKey;
    return state.setIn(['tables', tableKey, 'filters'], generateFilters(tableKey, state.getIn(['tables', tableKey, 'columns'])));
  },
  CLEAR_SELECTED_FILTERS: function CLEAR_SELECTED_FILTERS(state, _ref14) {
    var tableKey = _ref14.payload.tableKey;
    return state.setIn(['tables', tableKey, 'filters'], state.getIn(['tables', tableKey, 'appliedFilters']));
  }
});

function calculateRowsTask(_ref15) {
  var payload, tableKey, tableData, response, rows, data, nextPageToken, error, onFetch;
  return _regeneratorRuntime.wrap(function calculateRowsTask$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref15.payload;
          _context.prev = 1;
          tableKey = payload.tableKey;
          _context.next = 5;
          return select(function (state) {
            return state.getIn(['tables', tableKey]);
          });

        case 5:
          tableData = _context.sent;

          if (tableData) {
            _context.next = 8;
            break;
          }

          return _context.abrupt("return");

        case 8:
          _context.next = 10;
          return call(calculateRows, tableData);

        case 10:
          response = _context.sent;
          rows = response.rows, data = response.data, nextPageToken = response.nextPageToken, error = response.error;
          onFetch = tableData.get('onFetch');

          if (!error) {
            _context.next = 18;
            break;
          }

          _context.next = 16;
          return put({
            type: 'SET_ROWS',
            payload: {
              tableKey: tableKey,
              error: error,
              rows: List(),
              data: List(),
              nextPageToken: null
            }
          });

        case 16:
          _context.next = 20;
          break;

        case 18:
          _context.next = 20;
          return put({
            type: 'SET_ROWS',
            payload: {
              tableKey: tableKey,
              rows: rows,
              data: data,
              nextPageToken: nextPageToken
            }
          });

        case 20:
          if (!(typeof onFetch === 'function')) {
            _context.next = 23;
            break;
          }

          _context.next = 23;
          return call(onFetch, {
            tableKey: tableKey,
            rows: rows,
            error: error
          });

        case 23:
          _context.next = 28;
          break;

        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 25]]);
}

function configureTableTask(_ref16) {
  var payload, filterForm, tableKey, initialFilterValues;
  return _regeneratorRuntime.wrap(function configureTableTask$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref16.payload;
          filterForm = payload.filterForm, tableKey = payload.tableKey, initialFilterValues = payload.initialFilterValues;

          if (filterForm) {
            _context2.next = 7;
            break;
          }

          _context2.next = 5;
          return put(action('APPLY_FILTERS', {
            tableKey: tableKey
          }));

        case 5:
          _context2.next = 9;
          break;

        case 7:
          _context2.next = 9;
          return put(action('APPLY_FILTER_FORM', {
            tableKey: tableKey,
            appliedFilters: Map(initialFilterValues)
          }));

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var pollerTableKeys = {};

function pollingTask(tableKey) {
  return _regeneratorRuntime.wrap(function pollingTask$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 6;
            break;
          }

          _context3.next = 3;
          return delay(10000);

        case 3:
          refetchTable(tableKey);
          _context3.next = 0;
          break;

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function startPollingTask(_ref17) {
  var payload, refreshInterval, tableKey;
  return _regeneratorRuntime.wrap(function startPollingTask$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref17.payload;
          refreshInterval = payload.refreshInterval, tableKey = payload.tableKey;

          if (!(refreshInterval && !pollerTableKeys[tableKey])) {
            _context4.next = 6;
            break;
          }

          _context4.next = 5;
          return fork(pollingTask, tableKey, refreshInterval);

        case 5:
          pollerTableKeys[tableKey] = _context4.sent;

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function stopPollingTask(_ref18) {
  var payload, tableKey;
  return _regeneratorRuntime.wrap(function stopPollingTask$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref18.payload;
          tableKey = payload.tableKey;

          if (!pollerTableKeys[tableKey]) {
            _context5.next = 6;
            break;
          }

          _context5.next = 5;
          return cancel(pollerTableKeys[tableKey]);

        case 5:
          pollerTableKeys[tableKey] = null;

        case 6:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

regSaga('CONFIGURE_TABLE', /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeEvery('CONFIGURE_TABLE', configureTableTask);

        case 2:
          _context6.next = 4;
          return takeEvery('CONFIGURE_TABLE', startPollingTask);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee);
})); //

regSaga(takeEvery('UNMOUNT_TABLE', stopPollingTask));
regSaga(takeEvery('NEXT_PAGE', calculateRowsTask));
regSaga(takeEvery('PREV_PAGE', calculateRowsTask));
regSaga(takeEvery('GOTO_PAGE', calculateRowsTask));
regSaga(takeEvery('SORT_COLUMN', calculateRowsTask));
regSaga(takeEvery('SORT_DIRECTION', calculateRowsTask));
regSaga(takeEvery('APPLY_FILTERS', calculateRowsTask));
regSaga(takeEvery('APPLY_FILTER_FORM', calculateRowsTask));
regSaga(takeEvery('REFETCH_TABLE_DATA', calculateRowsTask));
export var operations = Map({
  includes: function includes(cv, v) {
    return cv.toLocaleLowerCase().includes(v.toLocaleLowerCase());
  },
  startsWith: function startsWith(cv, v) {
    return cv.toLocaleLowerCase().startsWith(v.toLocaleLowerCase());
  },
  equals: function equals(cv, v) {
    return typeof cv === 'string' ? cv.toLocaleLowerCase() === v.toLocaleLowerCase() : cv === v;
  },
  lt: function lt(cv, v) {
    return cv < v;
  },
  lteq: function lteq(cv, v) {
    return cv <= v;
  },
  gt: function gt(cv, v) {
    return cv > v;
  },
  gteq: function gteq(cv, v) {
    return cv >= v;
  },
  between: function between(cv, v) {
    return cv >= v.get(0) && cv < v.get(1);
  },
  "in": function _in(cv, v) {
    return v.reduce(function (found, value) {
      return found || (typeof value === 'string' ? cv.toLocaleLowerCase() === value.toLocaleLowerCase() : cv === value);
    }, false);
  }
});
export var isValueEmpty = function isValueEmpty(value) {
  if (value === null) {
    return true;
  } else if (typeof value === 'undefined') {
    return true;
  } else if (List.isList(value)) {
    if (value.isEmpty()) {
      return true;
    } else {
      return value.reduce(function (empty, v) {
        return empty && (!v || v === '');
      }, true);
    }
  } else if (value === '') {
    return true;
  }

  return !value;
};
export var clientSideRowFilter = function clientSideRowFilter(row, filters) {
  var usableFilters = filters.filter(function (filter) {
    return filter.get('value') !== '';
  }).map(function (filter, column) {
    return filter.set('currentValue', row.get(column));
  });
  return usableFilters.size === 0 ? true : usableFilters.reduce(function (has, filter) {
    var currentValue = filter.get('currentValue');
    var op = operations.get(filter.getIn(['column', 'filter']), function () {
      return true;
    });
    var value = filter.get('value');
    return isValueEmpty(value) ? has : op(currentValue, value);
  }, true);
};

var applyClientSideFilters = function applyClientSideFilters(tableData, data) {
  var pageOffset = tableData.get('pageOffset');
  var pageSize = tableData.get('pageSize');
  var sortColumn = tableData.get('sortColumn');
  var sortDirection = tableData.get('sortDirection');
  var filters = tableData.get('appliedFilters');
  var startIndex = pageOffset;
  var endIndex = Math.min(pageOffset + pageSize, data.size);
  var dataSource = getDataSource(tableData); // This is because the `defineFilter` function wants a native object
  // and not an Immutable map. This changes when we stop using the
  // `clientSideRowFilter` legacy function or when we support immutable
  // objects in the `defineFilter`.

  var clientSideFilters = filters.toJS();
  var rowFilter = !dataSource || dataSource.clientSideSearch === true ? function (row) {
    return clientSideRowFilter(row, filters);
  } : typeof dataSource.clientSide === 'function' ? function (row) {
    return dataSource.clientSide(row.toJS(), clientSideFilters);
  } : function () {
    return true;
  };
  return List(data).map(function (d) {
    return Map(d);
  }).update(function (d) {
    return d.filter(rowFilter);
  }).update(function (d) {
    return sortColumn ? d.sortBy(function (r) {
      return r.get(sortColumn.get('value'));
    }) : d;
  }).update(function (d) {
    return sortDirection === 'asc' ? d.reverse() : d;
  }).update(function (d) {
    return d.slice(startIndex, endIndex);
  });
};

var transformData = function transformData(data, tableData) {
  return data.map(function (row) {
    var columns = tableData.get('columns');
    return columns.reduce(function (rowData, column) {
      var valueTransform = column.get('valueTransform', function (v) {
        return v;
      });
      return rowData.update(column.get('value'), function (value) {
        return valueTransform(value, row);
      });
    }, row);
  });
};

var calculateRows = function calculateRows(tableData) {
  var dataSource = getDataSource(tableData);

  if (isClientSide(tableData)) {
    var data = transformData(tableData.get('data'), tableData);
    var rows = applyClientSideFilters(tableData, data);
    return Promise.resolve({
      rows: rows,
      data: data,
      count: rows.size
    });
  } else if (dataSource) {
    var paramData = {
      pageSize: tableData.get('pageSize'),
      filters: tableData.get('appliedFilters'),
      sortColumn: tableData.getIn(['sortColumn', 'value']),
      sortDirection: tableData.get('sortDirection'),
      nextPageToken: tableData.get('nextPageToken'),
      pageTokens: tableData.get('pageTokens')
    };

    var transform = dataSource.transform || function (result) {
      return result;
    };

    var params = dataSource.params(paramData);
    return dataSource.fn.apply(dataSource, _toConsumableArray(params)).then(function (response) {
      if (response.error) return response;

      var _transform = transform(response, paramData),
          nextPageToken = _transform.nextPageToken,
          responseData = _transform.data,
          count = _transform.count;

      var data = fromJS(responseData);
      var transformedRows = transformData(data, tableData);
      var rows = dataSource.clientSideSearch || dataSource.clientSide ? applyClientSideFilters(tableData, transformedRows) : transformedRows;
      return {
        nextPageToken: nextPageToken,
        count: dataSource.clientSideSearch || dataSource.clientSide ? rows.size : count,
        data: data,
        rows: rows
      };
    });
  } else {
    throw new Error('Unable to calculate rows: Missing both data and a dataSource!');
  }
};

export var filterFormKey = function filterFormKey(tableKey) {
  return "".concat(tableKey, ".filter-form");
};
export var mountTable = function mountTable(tableKey) {
  dispatch('MOUNT_TABLE', {
    tableKey: tableKey
  });
  mountForm(filterFormKey(tableKey));
};
export var unmountTable = function unmountTable(tableKey) {
  dispatch('UNMOUNT_TABLE', {
    tableKey: tableKey
  });
  unmountForm(filterFormKey(tableKey));
};
export var configureTable = function configureTable(payload) {
  dispatch('CONFIGURE_TABLE', payload);
};
export var refetchTable = function refetchTable(tableKey) {
  return dispatch('REFETCH_TABLE_DATA', {
    tableKey: tableKey
  });
};
export var clearFilters = function clearFilters(tableKey) {
  return dispatch('CLEAR_TABLE_FILTERS', {
    tableKey: tableKey
  });
};